import { css } from 'glamor';

export default css({
  bottom: 0,
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 4,
});
